import { render, staticRenderFns } from "./TypeChat.vue?vue&type=template&id=85df3e3c"
import script from "./TypeChat.vue?vue&type=script&lang=js"
export * from "./TypeChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85df3e3c')) {
      api.createRecord('85df3e3c', component.options)
    } else {
      api.reload('85df3e3c', component.options)
    }
    module.hot.accept("./TypeChat.vue?vue&type=template&id=85df3e3c", function () {
      api.rerender('85df3e3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TypeChat.vue"
export default component.exports